import { apiRequest } from './core/client';

export interface SubscriptionContactRef {
  id: string;
  accountId: string;
  approvedState: 'pending' | 'approved' | 'blocked' | null;
}

export interface Subscription {
  address: string;
  name: string | null;
  messages30d: number;
  messages90d: number;
  lastMessageAt: string | null;
  unsubscribeUrl: string | null;
  /** RFC 8058 one-click POST supported (server can unsubscribe without a tab) */
  oneClick: boolean;
  unsubscribedAt: string | null;
  unsubscribeMethod: 'one_click' | 'mailto' | 'link' | null;
  blocked: boolean;
  contacts: SubscriptionContactRef[];
}

export interface ListSubscriptionsResponse {
  subscriptions: Subscription[];
}

export async function fetchSubscriptions(
  accountId: string,
  options: { activeWithinDays?: number; minMessages?: number } = {}
): Promise<ListSubscriptionsResponse> {
  return await apiRequest<ListSubscriptionsResponse>({
    path: '/subscriptions',
    accountId,
    query: {
      active_within_days: options.activeWithinDays,
      min_messages: options.minMessages,
    },
  });
}

export type UnsubscribeResult =
  | { success: true; method: 'one_click'; status: number }
  | { success: true; method: 'mailto'; to: string }
  | { success: true; method: 'link'; url: string };

export async function unsubscribeFromSender(
  accountId: string,
  senderEmail: string
): Promise<UnsubscribeResult> {
  return await apiRequest<UnsubscribeResult>({
    path: '/subscriptions/unsubscribe',
    method: 'POST',
    accountId,
    body: { senderEmail },
  });
}
